'use client'

import Image from 'next/image'
import { useElementVisible } from '@hooks/useElementVisible'
import { Container, Flex } from '@quark/layout'
import { Animations, MultiReveal } from '@quark/animation'
import { Text } from '@quark/typography'
import isMobile from 'ismobilejs'
import styles from './recognition.module.scss'

const Recognition = data => {
  const containerSection = useElementVisible({ threshold: 0.2 })
  const isMobileDevice = isMobile()?.phone

  return (
    <Container type="fluid" paddingTop={{ lg: 'spacing-72', md: 'spacing-56', sm: 'spacing-40' }}>
      <MultiReveal
        as={Flex}
        flexDirection="column"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        animationDelays={(i: number) => 300 + i * 100}
        animationProps={{ animation: Animations.FadeIn50px }}>
        <div className={styles.textContainer}>
          <Image
            src={data?.ackoLogoUrl?.url}
            alt="acko-logo"
            width={isMobileDevice ? 150 : 300}
            height={isMobileDevice ? 36 : 72}
          />
          <Container
            type="root"
            paddingTop={{ lg: 'spacing-48', md: 'spacing-32', sm: 'spacing-24' }}
            paddingBottom="spacing-16">
            <Text
              as="p"
              fontStyle={{ lg: 'um_text-xl/normal', md: 'um_text-lg/normal', sm: 'um_text-lg/normal' }}
              color="base/primary"
              textAlign="center">
              {data?.title}
            </Text>
          </Container>
          <Text
            as="p"
            fontStyle={{ lg: 'um_text-4xl/bold', md: 'um_text-3xl/bold', sm: 'um_text-2xl/bold' }}
            color="base/primary"
            textAlign="center">
            {data?.subtitle}
          </Text>
        </div>
        <div
          ref={containerSection.ref}
          className={`${styles.container} ${containerSection.isVisible ? styles.animate : ''}`}>
          <div className={styles.curveBase} />
          {data?.recognitionImageList?.map((recognition, index) => (
            <Image
              key={index}
              src={recognition?.url}
              alt={recognition?.title}
              width={210}
              height={250}
              className={`${styles.image} ${styles[`position${index}`]}`}
            />
          ))}
        </div>
      </MultiReveal>
    </Container>
  )
}

export default Recognition
